export const isIdValid = (id: string): boolean => !isNaN(parseInt(id));
